import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from "react";
// import AdminDashboard from './modules/dashboard/adminDashboard'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ClientForm from './modules/client/form';
import ClientList from './modules/client/list';
import ClientEdit from './modules/client/edit';
import EmployeeForm from './modules/employee/form';
import EmployeeList from './modules/employee/list';
import EmployeeEdit from './modules/employee/edit';
import TasksForm from './modules/task/form';
import TasksList from './modules/task/list';
import TasksEdit from './modules/task/edit';
import Login from './Login';
import NavManager from './NavManager';
import NavEmp from './NavEmp';
import AssignedTasks from './modules/task/assignedtasks';
import TasksUpdate from './modules/task/updatetask';

const App = () => {
  const [isLoggedIn, setLogin] = useState(false)
  const [user, setUser] = useState({position:""});

  if (!isLoggedIn) {
    return (
      <Login isLoggedIn={isLoggedIn} setLogin={setLogin} setUser={setUser} />
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Conditionally render the manager or employee navigation based on the position */}
        {user['position'] === 'Manager' ? 
          <Route path="/" element={<NavManager isLoggedIn={isLoggedIn} setLogin={setLogin} />}>
            <Route path="/employee/list" element={<EmployeeList />} />
            <Route path="/employee/create" element={<EmployeeForm />} />
            <Route path="/employee/edit" element={<EmployeeEdit />} />
            <Route path="/client/list" element={<ClientList />} />
            <Route path="/client/create" element={<ClientForm />} />
            <Route path="/client/edit" element={<ClientEdit />} />
            <Route path="/tasks/list" element={<TasksList />} />
            <Route path="/tasks/create" element={<TasksForm />} />
            <Route path="/tasks/edit" element={<TasksEdit />} />
            <Route path="/login" element={<Login isLoggedIn={isLoggedIn} setLogin={setLogin} setUser={setUser} />} />
          </Route>
        : <></>}

        {user['position'] === 'Employee' ? 
          <Route path="/" element={<NavEmp isLoggedIn={isLoggedIn} setLogin={setLogin}/>}> 
            <Route path="/tasks/list" element={<AssignedTasks user={user} />} />
            <Route path="/tasks/edit" element={<TasksUpdate />} />
            <Route path="/login" element={<Login isLoggedIn={isLoggedIn} setLogin={setLogin} setUser={setUser} />} />
          </Route>
        : <></>}
      </Routes>
    </BrowserRouter>

  );
}

export default App;


export function MyFetch(url, data = {}, method = 'POST') {
  let bearer = 'Bearer ' + localStorage.getItem('jwt');
  return fetch(url, {  // Return promise
    method: method,
    mode: "cors",
    withCredentials: true,
    // credentials: 'include',
    headers: {
      'Authorization': bearer,
      'Content-Type': 'application/json'
    },
    body: method === 'GET' ? null : JSON.stringify(data) // Include data for non-GET requests
  })
}